import EventEmitter from '../../../../utils/EventEmitter.js'

export default class Sizes extends EventEmitter {
  constructor(container) {
    super()

    this.container = container
    this.updateSizes()
    this.setupEventListeners()
    this.resizeTimeout = null
  }

  updateSizes() {
    const rect = this.container.getBoundingClientRect()
    this.width = rect.width
    this.height = rect.height
    this.pixelRatio = Math.min(window.devicePixelRatio, 2)
    this.aspect = this.width / this.height
  }

  setupEventListeners() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.debouncedResize()
    })
    this.resizeObserver.observe(this.container)
  }

  debouncedResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }

    this.resizeTimeout = setTimeout(() => {
      this.resize()
    }, 200)
  }

  resize() {
    this.updateSizes()
    this.trigger('resize')
  }
}
